import {Component, Prop} from 'vue-facing-decorator';
import {StyleAppearance} from '@/app/constants/styles/StyleAppearance';
import {StyleSize} from '@/app/constants/styles/StyleSize';
import {FormFieldRadio} from '@/app/views/components/form/FormFieldRadio';
import {IIcon} from '@/app/views/components/misc/Icon';

@Component({})
export default class FormFieldRadioCard extends FormFieldRadio {

    @Prop({type: String, required: true})
    public label: string;

    @Prop({type: String, default: null})
    public supportText: string;

    @Prop({type: Object, default: null})
    public icon: IIcon;

    @Prop({type: String, default: 'green'})
    public activeColor: string;

    @Prop({type: String, default: StyleAppearance.SECONDARY})
    public appearance: StyleAppearance;

    @Prop({type: String, default: StyleSize.MEDIUM})
    public size: StyleSize;

    @Prop({type: Boolean, default: true})
    public isLight: boolean;

    public get formFieldClassList(): string {
        let clss: string = 'form-field';
        if (this.activeColor) {
            clss += ' ' + this.activeColor;
        }
        if (this.appearance) {
            clss += ' ' + this.appearance;
        }
        if (this.size) {
            clss += ' ' + this.size;
        }
        if (this.isLight) {
            clss += ' light';
        }

        return clss;
    }


}
